export default "__VITE_ASSET__Chms2Dcs__"